module.exports = __webpack_public_path__ + "chores.jpg";